import { CertBubbleLegendGroup, CertBubbleSeries } from "../../../../components/cert/cert-chart-generic/types";
import { DnsFirewallTypeEdge } from "../../../../gql/generated";

export const chartDataTransform = (data: DnsFirewallTypeEdge[]): CertBubbleSeries[] => {
  if (!data || data.length === 0) {
    return [];
  }

  const series: Map<string, CertBubbleSeries> = new Map();

  data.forEach((edge) => {
    const { node } = edge;
    if (!series.has(node.rpzFeed)) {
      series.set(node.rpzFeed, { name: node.rpzFeed, value: 0 });
    }
    series.get(node.rpzFeed).value++;
  });

  return [...series.values()];
};

/**
 * Transform given edges into a group of labels with their percentage of the total.
 *
 * @param data A list of firewall edges
 * @returns Legend groups
 */
export const chartLegendTransform = (data: DnsFirewallTypeEdge[]): CertBubbleLegendGroup[] => {
  if (!data || data.length === 0) {
    return [];
  }
  const transformed = chartDataTransform(data);
  const total = data.length;
  const legendGroups: CertBubbleLegendGroup[] = transformed.map((series) => ({
    name: series.name,
    percentage: total > 0 ? (series.value / total) * 100 : 0,
  }));
  return legendGroups.sort((a, b) => b.percentage - a.percentage);
};
